<template>
  <div class="chat-cont">
    <VueChat :contactId="contactId"></VueChat>
  </div>
</template>

<script>
import VueChat from "@/components/VueChat/index";
export default {
  components: {
    VueChat,
  },
  data() {
    return {
      id: "",
    };
  },
  created() {
    this.contactId = this.$route.query.contactId;
  },
};
</script>

<style lang="scss" scoped>
.chat-cont {
  width: 100vw;
  height: 100vh;
  background: #2e2f3d;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>